let _canUseWebGL;

const detectWebGLContext = () => {
    try {
        if (
            typeof localStorage !== 'undefined' &&
            localStorage &&
            localStorage.disableWebGL
        ) {
            return false;
        }
    } catch (e) {
        // Do nothing: access to localStorage is not granted: disableWebGL was not set
        // This does not mean WebGL is supported: keep going with the checks.
    }
    // Create canvas element. The canvas is not added to the
    // document itself, so it is never displayed in the
    // browser window.
    if (typeof document === 'undefined') {
        return false;
    }
    const canvas = document.createElement('canvas');
    // Get WebGLRenderingContext from canvas element.
    const gl =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    // Report the result.

    if (gl) {
        if (typeof WebGLRenderingContext !== 'undefined') {
            if (gl instanceof WebGLRenderingContext) {
                return true;
            }
        }
    }

    return false;
};

const isWebGLPresent = () => {
    if (_canUseWebGL === undefined) {
        _canUseWebGL = detectWebGLContext();
    }
    return _canUseWebGL;
};

const resetCache = () => {
    _canUseWebGL = undefined;
};

export default {
    isWebGLPresent,
    resetCache,
};
